import { type TileIndex } from "@/types/tile";
import { FrameName } from "../config";
import TileEntity from "../TileEntity";

class AppleGroveBuildingTileEntity extends TileEntity {
	public static readonly frameName = FrameName.APPLE_GROVE;

	public get suppliesTileIndexes(): Set<TileIndex> {
		return new Set<TileIndex>(
			// zasobuje len 1 apple orchard
			Array.from(super.suppliesTileIndexes).slice(0, 1),
		);
	}
}

export default AppleGroveBuildingTileEntity;
